import {
	GetGradingScaleActionsTypes, GetGradingScalesActionsTypes, CreateGradingScaleActionsTypes, UpdateGradingScaleActionsTypes, DeleteGradingScaleActionsTypes,
	IGradingScalesState,
	GradingScaleActions,
} from './types';

const initialState : IGradingScalesState = {
	gradingScales: [],
	selectedGradingScale: null,
	selectedId: -1,
    loading: false,
    error: '',
    success: false,
	create: {
        loading: false,
        error: '',
        success: false,
    },
	update: {
        loading: false,
        error: '',
        success: false,
    },
	delete: {
        loading: false,
        error: '',
        success: false,
    }
};

const gradingScalesReducer = (state: IGradingScalesState = initialState, action: GradingScaleActions) => {
	switch (action.type) {
		
		// ----------------------Get Grading Scale Actions-----------------------
		case GetGradingScaleActionsTypes.GET_GRADING_SCALE: {
			return {
				...state,
				loading: true
			};
		}
		case GetGradingScaleActionsTypes.GET_GRADING_SCALE_SUCCESS: {
			const { loading, data, id} = action;
			return {
				...state,
				selectedGradingScale: data,
				selectedId: id,
				loading, success: true
			};
		}
		case GetGradingScaleActionsTypes.GET_GRADING_SCALE_ERROR: {
			const { error, loading } = action;
			return {
				...state,
				loading: false, success: false, error: error
			};
		}

		// ----------------------Get Grading Scales Actions-----------------------
		case GetGradingScalesActionsTypes.GET_GRADING_SCALES: {
			return {
				...state,
				loading: true
			};
		}
		case GetGradingScalesActionsTypes.GET_GRADING_SCALES_SUCCESS: {
			const { loading, data} = action;
			return {
				...state,
				loading, 
				success: true,
				selectedId: -1,
				gradingScales: data.data.gradingScales,
				create: { success: false, loading: false, error: '' },
				update: { success: false, loading: false, error: '' },
				delete: { success: false, loading: false, error: '' }
			};
		}	
		case GetGradingScalesActionsTypes.GET_GRADING_SCALES_ERROR: {
			const { error, loading } = action;
			return {
				...state,
				loading: false, success: false, error: error
			};
		}				

		// ----------------------Create Grading Scale Actions-----------------------
		case CreateGradingScaleActionsTypes.POST_CREATE_GRADING_SCALE: {
			return {
				...state,
				create: { loading: true, success: false, error: '' }
			};
		}
		case CreateGradingScaleActionsTypes.POST_CREATE_GRADING_SCALE_SUCCESS: {
			return {
				...state,
				create: { success: true, loading: false, error: '' }
			};
		}	
		case CreateGradingScaleActionsTypes.POST_CREATE_GRADING_SCALE_ERROR: {
			const { error } = action;
			return {
				...state,
				create: { success: false, loading: false, error: error || 'Failed to create grading scale' }
			};
		}				

		// ----------------------Update Grading Scale Actions-----------------------
		case UpdateGradingScaleActionsTypes.PUT_UPDATE_GRADING_SCALE: {
			return {
				...state,
				update: { loading: true, success: false, error: '' }
			};
		}
		case UpdateGradingScaleActionsTypes.PUT_UPDATE_GRADING_SCALE_SUCCESS: {
			return {
				...state,
				update: { success: true, loading: false, error: '' }
			};
		}	
		case UpdateGradingScaleActionsTypes.PUT_UPDATE_GRADING_SCALE_ERROR: {
			const { error } = action;
			return {
				...state,
				update: { success: false, loading: false, error: error || 'Failed to update grading scale' }
			};
		}				

		// ----------------------Delete Grading Scale Actions-----------------------
		case DeleteGradingScaleActionsTypes.DELETE_GRADING_SCALE: {
			return {
				...state,
				loading: true
			};
		}
		case DeleteGradingScaleActionsTypes.DELETE_GRADING_SCALE_SUCCESS: {
			return {
				...state,
				delete:{success:true, loading: false}
			};
		}	
		case DeleteGradingScaleActionsTypes.DELETE_GRADING_SCALE_ERROR: {
			const { error, loading } = action;
			return {
				...state,
				delete:{success:false, loading: false}
			};
		}				
		default:
			return state;
	}
};

export default gradingScalesReducer;
